import React from "react";
import { Link } from "react-router-dom";

import {
  Card,
  Table,
  TableHead,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
  Text,
  Title,
} from "@tremor/react";

// Τα δικόγραφα που αφορά η υπόθεση (καρτέλα «Αφορά Δικόγραφα» του Solon). Όταν ένα
// από αυτά είναι στη λίστα του χρήστη (linkedCases), η γραμμή οδηγεί σε αυτό.
const AforaDikografa = ({ data, linkedCases = [] }) => {
  const ownCaseId = (item) =>
    linkedCases.find(
      (linked) =>
        String(linked.gak) === String(item.gak).trim() &&
        String(linked.year) === String(item.etos).trim()
    )?.case_id;

  return (
    <Card className="mt-3">
      <Title>Αφορά Δικόγραφα</Title>
      <Table>
        <TableHead>
          <TableRow>
            <TableHeaderCell>ΓΑΚ</TableHeaderCell>
            <TableHeaderCell>ΕΤΟΣ</TableHeaderCell>
            <TableHeaderCell>Στη λίστα σας</TableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, i) => (
            <TableRow key={`afora-${i}`}>
              <TableCell>{item.gak}</TableCell>
              <TableCell>
                <Text>{item.etos}</Text>
              </TableCell>
              <TableCell>
                {ownCaseId(item) ? (
                  <Link to={`/cases/${ownCaseId(item)}`}>Προβολή υπόθεσης</Link>
                ) : (
                  "—"
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
};

export default AforaDikografa;
